import Network from '@/services/network'

export default function handleCompliance() {
    const network = new Network;
    
    // ********************* Tds-Vds-Register-start *****************
    const fetchTdsVdsRegister = (query) => {
        return network.api('get', '/compliance/tds-vds/register-list' + query);
    }
    const fetchTdsVdsRegisterClientWise = (query) => {
        return network.api('get', '/compliance/tds-vds/register-list-client' + query);
    }
    // ********************* Tds-Vds-Register-End *****************
    

    // ********************* Challan-Register-start *****************
    const fetchChallanRegister = (query) => {
        return network.api('get', '/compliance/challan-register/list' + query);
    }
    const storeChallanRegister = (data) => {
        return network.api('post', '/compliance/challan-register/create-challan', data);
    }
    const fetchSingleChallan = (query, id) => {
        return network.api('get', '/compliance/challan-register/show/' + id + query);
    }
    const updateChallanRegister = (data, id) => {
        return network.api('post', '/compliance/challan-register/update/' + id, data);
    }
    // ********************* Challan-Register-End **********************


    return {
        fetchTdsVdsRegister,
        fetchTdsVdsRegisterClientWise,
        storeChallanRegister,
        fetchChallanRegister,
        fetchSingleChallan,
        updateChallanRegister
    }
}